import moment from 'moment';

export const data = () => {
    return {
        year: moment().format('YYYY'),
        file: null
    };
};

export default {
    data: data(),
    preloader: false,
    sales_budget: [],
    modal: {
        show: false
    }
};



// WEBPACK FOOTER //
// ./src/modules/sales_budget_by_contacts_warehouses/state.js